<div
    class="bp-heading builder-cover-bg"
	[style.background-color]="data.bg_color"
	[style.background-image]="data.hide_bg_image || !data.bg_thumbnail ? '' : ('url(' + data.bg_thumbnail.url + ')')"

>
    <div
		class="bp-heading-holder builder-default-layout"
		[style.max-width]="desktopWidth + 'px'"
    >
      	<div [innerHTML]="trustedTitle"></div>
    </div>
</div>